<template>
  <ContentBlock title='我的企业列表' class="JZContent company-list">
    <xz-table
      ref="xzTable"
      :columns="columnLists"
      :data="data"
      :scroll="{ x: '100%', y: scrollHeight }"
      :drawerWidth="500"
      rowKey="id">
      <template slot="authenticationStatus" slot-scope="status">
        <span :class="['c_tag', status ? getColor(status) : '']">
          {{ [3, '3'].includes(status) ? '已认证' : [2, '2'].includes(status) ? '认证中' : [1, '1'].includes(status) ? '未认证' : '--'}}
        </span>
      </template>
      <template slot="action" slot-scope="_, record">
        <template v-if="record.defaultTenantFlag !== 1 && record.accountStatus === 'ACTIVE' && record.trialStatus === 'use'">
          <a @click="() => handleAction(record, 'modify')" style="margin-left: 8px">设为默认</a>
        </template>
      </template>
    </xz-table>
  </ContentBlock>
</template>
<script>
import LoginApi from '@/api/login';
import { myTenantList, updateDefaultTenant } from '@/api/company';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';

const COMMON_COLUMNS = [
  {
    title: '企业名称',
    dataIndex: 'tenantName',
    key: 'tenantName',
    width: 300,
    ellipsis: true,
    customRender: (text, row) => {
      return row.isPersonal ? '个人' : text || '--';
    },
  },
  {
    title: '认证状态',
    dataIndex: 'authenticationStatus',
    key: 'authenticationStatus',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'authenticationStatus' },
  },
  {
    title: '账号状态',
    dataIndex: 'trialStatusDesc',
    key: 'trialStatusDesc',
    width: 150,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '是否默认',
    dataIndex: 'defaultTenantFlag',
    key: 'defaultTenantFlag',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text !== null && text !== undefined ? text ? '是' : '否' : '--';
    },
  },
  {
    title: '我的企业身份',
    dataIndex: 'roleNamesStr',
    key: 'roleNamesStr',
    width: 260,
    ellipsis: true,
    customRender: (text, row) => {
      return row.isPersonal ? '--' : text || '--';
    },
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    fixed: 'right',
    width: 150,
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  components: {
    xzTable,
  },
  data () {
    return {
      columnLists: [
        ...COMMON_COLUMNS,
      ],
      scrollHeight: 700,
      data: [],
    };
  },
  methods: {
    getColor (v) {
      const green = [3, '3'];
      const grey = [1, '1'];
      const bule = [2, '2'];
      if (green.includes(v)) return 'green';
      if (grey.includes(v)) return 'grey';
      if (bule.includes(v)) return 'bule';
      return '';
    },
    handleAction (row, type) {
      if (type === 'modify') {
        this.$confirm(`是否确认将【${row.tenantName}】设为默认登录企业？`, '设为默认', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning',
        }).then(async () => {
          await updateDefaultTenant({ tenantId: row.tenantId });
          this.$message({
            type: 'success',
            message: '设置成功!',
          });
          this.queryCompanyLists();
          // 更新本地存储的企业列表
          const list = await LoginApi.ownerList();
          list.body = list.body.splice(list.body.findIndex(item => item.isPersonal), 1).concat(list.body);
          localStorage.setItem('haveCompany', list.body.length > 1 || false);
          localStorage.setItem('ownerList', JSON.stringify(list.body));
        });
      }
    },
    async queryCompanyLists () {
      const { body } = await myTenantList({
        findRoleFlag: true,
      });
      this.data = body || [];
    },
  },
  created () {
    this.queryCompanyLists();
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.company-list {
  height: calc(100% - 8px);
  .c_tag {
    @include tag_round();
    margin-right: 0.2em;
  }
  .green {
    background: #E5FEEB;
    color: #14CA64;
  }
  .grey {
    background-color: #F2F4F7;
    color: #1F2733;
  }
  .bule {
    background: #e2f3fe;
    color: #237ffa;
  }
}
</style>
